import { useState } from "react";
import Button from "../components/Button";
import styles from "./AddEmployeeModal.module.css";
import { validateForm } from "../helpers/helperFunctions";
import React from "react";

function AddEmployeeModal({ eventData, getServers, servData, makeInvalid }) {
  const [isOpen, setIsOpen] = useState(false);
  //const navigate = useNavigate();
  const [employee, setEmployee] = useState("");
  const [job, setJob] = useState("");
  const user = JSON.parse(localStorage.getItem("userLogin")).userId;
  const openModal = () => {
    setIsOpen((x) => !x);
  };
  const closeModal = () => {
    setIsOpen((x) => !x);
    setJob("");
    setEmployee("");
  };

  //let filterdData = servData.filter((sd) => sd.category == 'Chef')

  const addEmployee = async function (e) {
    e.preventDefault();
    if (validateForm(e.target)) {
      await fetch("/api/servers", {
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          empName: e.target.empName.value,
          banID: eventData.idBanquetHeader,
          cat: e.target.empType.value,
          user: user,
        }),
      });
      getServers();

      closeModal();
    }
  };

  return (
    <>
      <Button type="tertiary" onClick={openModal}>
        Add Employee
      </Button>
      {isOpen && (
        <div className="modal-backdrop modal-backdrop-dark">
          <div className={`modal-content ${styles.modalTop}`}>
            <h3 className="modal-header">Add Employee</h3>
            <div className={styles.employeeModalBody}>
              <form action="" onSubmit={addEmployee} noValidate>
                <div className={styles.employeeName}>
                  <div className="formSection">
                    <label htmlFor="">Employee Name:</label>
                    <input
                      type="text"
                      id="addEmployeeName"
                      name="empName"
                      value={employee}
                      onChange={(e) => setEmployee(e.target.value)}
                      required
                      onInvalid={makeInvalid}
                    />
                    <div className="invalid-feedback">Server/Employee name required</div>
                  </div>
                </div>
                <div className={styles.employeeType}>
                  <div className="formSection">
                    <label>Employee type:</label>
                    <select value={job} name="empType" onChange={(e) => setJob(e.target.value)} required onInvalid={makeInvalid} defaultValue={""}>
                      <option value="" className={styles.employeeSelectOption}>
                        --Select Job--
                      </option>
                      <option value="Server" className={styles.employeeSelectOption}>
                        Server
                      </option>
                      <option value="Chef">Chef/Kit</option>
                      <option value="Coordinator">Coordinator</option>
                      <option value="Bar">Bar</option>
                      <option value="Dish">Dish</option>
                    </select>
                    <div className="invalid-feedback">Server/Employee job type required</div>
                  </div>
                </div>
                <div className={styles.formSelectButtons}>
                  <Button type="primary">Save</Button>
                  <Button type="save" onClick={closeModal}>
                    Close
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default AddEmployeeModal;
